import React from 'react'
import './index.scss';
import './App.css';


export default () => {
    return (
    <div style={{width:"100%", height:"100%"}}>
        <div className='about'>

            <h3 style={{ textAlign: "center" }}>
                I am third year Computer Science student minoring in Databases at Polish Japanese Academy of Information Technology.
                Currently based in Warsaw, Poland.
            </h3>
            <h2 style={{ textAlign: "center" }}>
                My greatest interest right now is Web Development. 
            </h2>


        </div>
    </div>
    )
}